import CustomDisclaimer from './CustomDisclaimer';

export default CustomDisclaimer;
